module.exports = __webpack_public_path__ + "static/img/skin-report-2.60a7888.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skinReport/skin-report-2.png
// module id = GIAA
// module chunks = 1